import { useAuth0 } from 'app/Auth'
import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { GetPrefCardsResponse } from './types'

export const useGetPreferenceCardsToBeAssigned = ({
  surgeonId,
  surgeryId,
  searchName,
}: {
  surgeonId: string
  surgeryId: string
  searchName?: string
}) => {
  const { getAccessToken } = useAuth0()
  const tokenPromise = getAccessToken()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  return useQuery<GetPrefCardsResponse, AxiosError | any>(
    ['preferenceCards', surgeonId, surgeryId, searchName],
    async () => {
      const token = await tokenPromise
      try {
        const response = await axios.get(
          `${REPORTS_URL}api/v1/preference_cards/surgeon/${surgeonId}/available/${surgeryId}`,
          {
            params: searchName
              ? {
                  search_name: searchName,
                }
              : undefined,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        )
        return response.data
      } catch (error) {
        throw error
      }
    },
    {
      enabled: !!surgeonId && !!surgeryId,
    }
  )
}